import { render, staticRenderFns } from "./member_review.vue?vue&type=template&id=1b85f1f6&scoped=true"
import script from "./member_review.vue?vue&type=script&lang=ts"
export * from "./member_review.vue?vue&type=script&lang=ts"
import style0 from "./member_review.vue?vue&type=style&index=0&id=1b85f1f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b85f1f6",
  null
  
)

export default component.exports